import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import { useMemo } from 'react';
import useServices from '../../hooks/useServices';
import { exploreRestaurantsGraphqlQuery } from './graphqlQueries';

var ServiceRestaurants = /*#__PURE__*/function (_Service) {
  _inherits(ServiceRestaurants, _Service);

  var _super = _createSuper(ServiceRestaurants);

  function ServiceRestaurants() {
    _classCallCheck(this, ServiceRestaurants);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceRestaurants, [{
    key: "fetchRestaurants",
    value: function fetchRestaurants(_ref) {
      var limit = _ref.limit,
          offset = _ref.offset,
          order_by = _ref.order_by,
          filters = _ref.filters;
      return this.axiosInstance.get(ENDPOINTS.restaurants.root, {
        params: _objectSpread({
          limit: limit,
          offset: offset,
          order_by: order_by
        }, filters)
      });
    }
  }, {
    key: "createRestaurant",
    value: function createRestaurant(params) {
      return this.axiosInstance.post(ENDPOINTS.restaurants.root, params);
    }
  }, {
    key: "fetchRestaurantIds",
    value: function fetchRestaurantIds(_ref2) {
      var showDetails = _ref2.showDetails,
          limit = _ref2.limit;
      return this.axiosInstance.get(ENDPOINTS.restaurants.restaurantIds, {
        params: {
          show_details: showDetails,
          limit: limit
        }
      });
    }
  }, {
    key: "showRestaurant",
    value: function showRestaurant(restaurantId) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.root + '/' + restaurantId);
    }
  }, {
    key: "showPublicRestaurant",
    value: function showPublicRestaurant(restaurantId) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.publicRestaurant + '/' + restaurantId);
    }
  }, {
    key: "updateRestaurant",
    value: function updateRestaurant(_ref3) {
      var restaurantId = _ref3.restaurantId,
          params = _ref3.params;
      return this.axiosInstance.put(ENDPOINTS.restaurants.root + '/' + restaurantId, params);
    }
  }, {
    key: "updateRestaurantOwnerPicture",
    value: function updateRestaurantOwnerPicture(_ref4) {
      var restaurantId = _ref4.restaurantId,
          file = _ref4.file;
      var formData = new FormData();
      formData.append('owner_profile_picture', file);
      return this.axiosInstance.put(ENDPOINTS.restaurants.root + '/' + restaurantId, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "uploadPicture",
    value: function uploadPicture(_ref5) {
      var restaurantId = _ref5.restaurantId,
          file = _ref5.file,
          _ref5$position = _ref5.position,
          position = _ref5$position === void 0 ? 'last' : _ref5$position;
      var formData = new FormData();
      formData.append('id', restaurantId);

      if (Array.isArray(file)) {
        file === null || file === void 0 ? void 0 : file.forEach(function (image) {
          formData.append('picture[]', image);
        });
      } else {
        formData.append('picture', file);
      }

      formData.append('position', position);
      return this.axiosInstance.post(ENDPOINTS.restaurants.picture, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    } // using the same endpoint with different parameters

  }, {
    key: "uploadRestaurantLogo",
    value: function uploadRestaurantLogo(_ref6) {
      var restaurantId = _ref6.restaurantId,
          file = _ref6.file;
      var formData = new FormData();
      formData.append('id', restaurantId);
      formData.append('restaurant_logo', file);
      return this.axiosInstance.post(ENDPOINTS.restaurants.picture, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "deletePicture",
    value: function deletePicture(_ref7) {
      var restaurantId = _ref7.restaurantId,
          pictureUrl = _ref7.pictureUrl;
      return this.axiosInstance["delete"](ENDPOINTS.restaurants.picture, {
        data: {
          id: restaurantId,
          url: pictureUrl
        }
      });
    }
  }, {
    key: "fetchLocalities",
    value: function fetchLocalities(_ref8) {
      var organizationId = _ref8.organizationId;
      return this.axiosInstance.get(ENDPOINTS.restaurants.localities, {
        params: {
          organization_id: organizationId
        }
      });
    }
  }, {
    key: "fetchRestaurantNames",
    value: function fetchRestaurantNames(_ref9) {
      var organization_id = _ref9.organization_id;
      return this.axiosInstance.get(ENDPOINTS.restaurants.restaurantNames, {
        params: {
          organization_id: organization_id
        }
      });
    }
  }, {
    key: "restaurantPlacesInfo",
    value: function restaurantPlacesInfo(restaurant_id) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.gMapPlaces, {
        params: {
          restaurant_id: restaurant_id
        }
      });
    }
  }, {
    key: "fetchPopularLocalities",
    value: function fetchPopularLocalities(limit) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.popularLocalities, {
        params: {
          limit: limit
        }
      });
    }
  }, {
    key: "fetchExploreRestaurantsList",
    value: function () {
      var _fetchExploreRestaurantsList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, config) {
        var r;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axiosInstance.post(ENDPOINTS.employers.graphql, {
                  query: exploreRestaurantsGraphqlQuery,
                  variables: _objectSpread({}, params)
                }, _objectSpread({}, config));

              case 2:
                r = _context.sent;
                return _context.abrupt("return", r);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchExploreRestaurantsList(_x, _x2) {
        return _fetchExploreRestaurantsList.apply(this, arguments);
      }

      return fetchExploreRestaurantsList;
    }()
  }, {
    key: "getRestaurantLocationCoordinates",
    value: function getRestaurantLocationCoordinates(params) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.restaurantLocationCoordinates, {
        params: params
      });
    }
  }, {
    key: "fetchRestaurantEmployees",
    value: function fetchRestaurantEmployees(restaurantId) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.members, _objectSpread({}, restaurantId ? {
        params: {
          restaurant_id: restaurantId
        }
      } : {}));
    }
  }, {
    key: "createRestaurantEmployee",
    value: function createRestaurantEmployee(params) {
      var formData = new FormData();
      formData.append('restaurant_id', params.restaurant_id);
      formData.append('full_name', params.full_name);
      if (params.occupation) formData.append('occupation', params.occupation);
      if (params.picture) formData.append('picture', params.picture);
      if (params.age) formData.append('age', params.age.toString());
      if (params.short_presentation) formData.append('short_presentation', params.short_presentation);
      return this.axiosInstance.post(ENDPOINTS.restaurants.employees, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "getRestaurantEmployeesById",
    value: function getRestaurantEmployeesById(restaurantEmployeeId) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.employees + '/' + restaurantEmployeeId);
    }
  }, {
    key: "updateRestaurantEmployee",
    value: function updateRestaurantEmployee(_ref10) {
      var _params$picture, _params$age$toString, _params$age, _params$short_present;

      var restaurantEmployeeId = _ref10.restaurantEmployeeId,
          params = _ref10.params;
      var formData = new FormData();
      if (params.restaurant_id) formData.append('restaurant_id', params.restaurant_id);
      if (params.full_name) formData.append('full_name', params.full_name);
      if (params.occupation) formData.append('occupation', params.occupation);
      if (params !== null && params !== void 0 && params.picture) formData.append('picture', (_params$picture = params === null || params === void 0 ? void 0 : params.picture) !== null && _params$picture !== void 0 ? _params$picture : '');
      if (params !== null && params !== void 0 && params.age) formData.append('age', (_params$age$toString = params === null || params === void 0 ? void 0 : (_params$age = params.age) === null || _params$age === void 0 ? void 0 : _params$age.toString()) !== null && _params$age$toString !== void 0 ? _params$age$toString : '');
      if (params !== null && params !== void 0 && params.short_presentation) formData.append('short_presentation', (_params$short_present = params === null || params === void 0 ? void 0 : params.short_presentation) !== null && _params$short_present !== void 0 ? _params$short_present : '');
      return this.axiosInstance.put(ENDPOINTS.restaurants.employees + '/' + restaurantEmployeeId, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "deleteRestaurantEmployee",
    value: function deleteRestaurantEmployee(restaurantEmployeeId) {
      return this.axiosInstance["delete"](ENDPOINTS.restaurants.employees + '/' + restaurantEmployeeId);
    }
  }, {
    key: "createOccupationTemplate",
    value: function createOccupationTemplate(params) {
      return this.axiosInstance.post(ENDPOINTS.restaurants.occupationTemplates, params);
    }
  }, {
    key: "fetchOccupationTemplates",
    value: function fetchOccupationTemplates(restaurantId) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.occupationTemplates, {
        params: {
          restaurant_id: restaurantId
        }
      });
    }
  }, {
    key: "updateOccupationTemplate",
    value: function updateOccupationTemplate(_ref11) {
      var _params$description;

      var occupationTemplateId = _ref11.occupationTemplateId,
          params = _ref11.params;
      return this.axiosInstance.put(ENDPOINTS.restaurants.occupationTemplates + '/' + occupationTemplateId, _objectSpread(_objectSpread({}, params), {}, {
        description: (_params$description = params.description) !== null && _params$description !== void 0 ? _params$description : ''
      }));
    }
  }, {
    key: "deleteOccupationTemplate",
    value: function deleteOccupationTemplate(occupationTemplateId) {
      return this.axiosInstance["delete"](ENDPOINTS.restaurants.occupationTemplates + '/' + occupationTemplateId);
    }
  }, {
    key: "fetchOccupationTemplate",
    value: function fetchOccupationTemplate(occupationTemplateId) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.occupationTemplates + '/' + occupationTemplateId);
    }
  }, {
    key: "showViolaBadge",
    value: function showViolaBadge(jobPositionId) {
      return this.axiosInstance.get(ENDPOINTS.restaurants.violaBadge, {
        params: {
          job_position_id: jobPositionId
        }
      });
    }
  }, {
    key: "setSeoData",
    value: function setSeoData(_ref12) {
      var restaurant_id = _ref12.restaurant_id,
          meta_description = _ref12.meta_description,
          meta_title = _ref12.meta_title,
          input_meta_image = _ref12.input_meta_image;
      var formData = new FormData();
      formData.append('id', restaurant_id);
      if (input_meta_image) formData.append('input_meta_image', input_meta_image);
      if (meta_description) formData.append('meta_description', meta_description);
      if (meta_title) formData.append('meta_title', meta_title);
      return this.axiosInstance.post("".concat(ENDPOINTS.restaurants.root, "/seo_metadata"), formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "associateNewReferentContact",
    value: function associateNewReferentContact(_ref13) {
      var restaurantId = _ref13.restaurantId,
          employerUserContactId = _ref13.employerUserContactId;
      return this.axiosInstance.post(ENDPOINTS.restaurants.referentContact, {
        restaurant_id: restaurantId,
        employer_user_contact_id: employerUserContactId
      });
    }
  }, {
    key: "removeReferentContactAssociation",
    value: function removeReferentContactAssociation(_ref14) {
      var restaurantId = _ref14.restaurantId,
          employerUserContactId = _ref14.employerUserContactId;
      return this.axiosInstance["delete"](ENDPOINTS.restaurants.referentContact, {
        data: {
          restaurant_id: restaurantId,
          employer_user_contact_id: employerUserContactId
        }
      });
    }
  }, {
    key: "createRestaurantViewLog",
    value: function createRestaurantViewLog(_ref15) {
      var restaurantId = _ref15.restaurantId,
          ambassadorCode = _ref15.ambassadorCode,
          utmSource = _ref15.utmSource;
      return this.axiosInstance.post(ENDPOINTS.restaurants.restaurantViewLog, {
        restaurant_id: restaurantId,
        ambassador_code: ambassadorCode,
        utm_source: utmSource
      });
    } // This doesnt return view logs, but the utm grouped data, which contains view and spontaneous_application counts

  }, {
    key: "getRestaurantViewLog",
    value: function getRestaurantViewLog(_ref16) {
      var restaurantId = _ref16.restaurantId,
          durationValue = _ref16.durationValue,
          durationUnit = _ref16.durationUnit;
      return this.axiosInstance.get("".concat(ENDPOINTS.restaurants.statistics, "/utm_source"), {
        params: {
          restaurant_id: restaurantId,
          duration_value: durationValue,
          duration_unit: durationUnit
        }
      });
    }
  }, {
    key: "fetchRestaurantStatistics",
    value: function fetchRestaurantStatistics(_ref17) {
      var restaurant_id = _ref17.restaurant_id,
          type = _ref17.type,
          duration_value = _ref17.duration_value,
          duration_unit = _ref17.duration_unit;
      // given type="chart" would return chart data as RestaurantChartStatistics type
      return this.axiosInstance.get(ENDPOINTS.restaurants.statistics, {
        params: {
          restaurant_id: restaurant_id,
          type: type,
          duration_value: duration_value,
          duration_unit: duration_unit
        }
      });
    }
  }, {
    key: "getAdditionalRestaurantOnboardingData",
    value: function getAdditionalRestaurantOnboardingData(_ref18) {
      var gmaps_place_id = _ref18.gmaps_place_id,
          restaurant = _ref18.restaurant;
      return this.axiosInstance.get(ENDPOINTS.restaurants.additionalOnboardingData, {
        params: {
          gmaps_place_id: gmaps_place_id,
          restaurant: restaurant
        }
      });
    }
  }, {
    key: "getOtherRestaurantValues",
    value: function getOtherRestaurantValues(_ref19) {
      var organizationId = _ref19.organizationId;
      return this.axiosInstance.get(ENDPOINTS.restaurants.otherRestaurantValues, {
        params: {
          organization_id: organizationId
        }
      });
    }
  }]);

  return ServiceRestaurants;
}(Service);

export var createRestaurantsService = function createRestaurantsService(_ref20) {
  var baseUrl = _ref20.baseUrl,
      jwt = _ref20.jwt;
  return new ServiceRestaurants(dynamicAxios(baseUrl, jwt));
};
export function useRestaurantsService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceRestaurants(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useRestaurantsService;
export * from './types';